// extracted by mini-css-extract-plugin
export default {"franchiseArea":"Franchise_franchiseArea__K6WS-"};